import { render, staticRenderFns } from "./ComprasXml.vue?vue&type=template&id=679e51ac"
import script from "./ComprasXml.vue?vue&type=script&lang=js"
export * from "./ComprasXml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports